// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__VJpRR","messages":"Chat_messages__2XXFg","dateDivider":"Chat_dateDivider__1oI-X"};